import type { SVGProps } from "react";
const SvgStorybook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <rect width="100%" height="100%" fill="#fff" />
    <path
      fill="#FF4785"
      d="M42.187 225.78 35.008 34.282c-.237-6.324 4.607-11.684 10.917-12.079l162.697-10.18c6.422-.402 11.954 4.485 12.355 10.914q.023.363.023.728v208.671c0 6.442-5.216 11.664-11.652 11.664q-.26 0-.522-.012l-155.519-6.992c-6.057-.273-10.893-5.15-11.12-11.216"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m196.064 13-22.418 1.398-1.094 26.229a1.743 1.743 0 0 0 2.791 1.455l10.213-7.729 8.626 6.78c.324.253.727.385 1.138.37a1.737 1.737 0 0 0 1.679-1.795zm-17.448 87.833c-4.104 3.18-34.673 5.35-34.673.823.646-17.275-7.107-18.032-11.414-18.032-4.092 0-10.983 1.233-10.983 10.488 0 9.431 10.071 14.755 21.892 21.004 16.793 8.877 37.115 19.622 37.115 46.657 0 25.913-21.104 40.227-48.024 40.227-27.781 0-52.059-11.212-49.317-50.086 1.077-4.564 36.395-3.48 36.395 0-.43 16.041 3.231 20.759 12.491 20.759 7.107 0 10.337-3.908 10.337-10.489 0-9.959-10.493-15.837-22.564-22.597-16.345-9.155-35.582-19.929-35.582-44.652 0-24.68 17.013-41.132 47.378-41.132 30.366 0 46.949 16.2 46.949 47.03"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStorybook;
